import { create } from "zustand";
import type { Manifest } from "../models";
import { loadManifest } from "../sources/manifest";

interface ManifestState {
  manifest: Manifest | null;
  error: string | null;
  loading: boolean;
  ensureLoaded(): Promise<void>;
}

export const useManifestStore = create<ManifestState>((set, get) => ({
  manifest: null,
  error: null,
  loading: false,
  async ensureLoaded() {
    if (get().manifest || get().loading) return;
    set({ loading: true, error: null });
    try {
      const manifest = await loadManifest();
      set({ manifest, loading: false });
    } catch (err) {
      set({ error: (err as Error).message, loading: false });
    }
  },
}));
